import React, {Component} from 'react';
import _ from "underscore";

import attributeIds from "../../../api/attributeIds";

import "../../../css/LocationDetail.css";

class AmenitiesPanel extends Component {
    getValuesForAttributeId(attributeId){
        var ret = [];
        if(!this.props.location.attributes[attributeId]){
            return false;
        }
        var choiceIds = this.props.location.attributes[attributeId].choice;
        for(var optionId in this.props.attributes[attributeId].options){
            if (_.contains(choiceIds, optionId)){
                ret.push(this.props.attributes[attributeId].options[optionId]);
            }
        }
        return ret;

    }

    render (){
        var amenities = this.getValuesForAttributeId(attributeIds.amenities);
        return(

        <div className="amenitiesSection">
            <div className="amenitiesTitle">Amenities</div>
            {amenities ?
                amenities.map((amenity, index) =>{
                    return(
                        <div className="container amenitiesItem" key={"amenity-container-" + index}>
                             <img className="quickFactsIcon" src={amenity.icon} alt="amenity icon"/>
                             <div className="amenitiesValue">{amenity.name}</div>
                         </div>
                    )
                })
                :
                <div style={{fontFamily: "Lato", fontSize: "16px", marginTop: "20px", color: "#1c5c7f"}}>This information is not available yet</div>
            }

        </div>
        )

    }
}

export default AmenitiesPanel;



// WEBPACK FOOTER //
// ./src/components/locator/details/AmenitiesPanel.js